<template>
    <div>
        <form @submit.prevent="update" enctype="multipart/form-data" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
                <div class="px-10 py-12">
                    <select-input v-model="form.designado" :error="form.errors.designado" class="pr-6 pb-8 w-full" label="¿Designado?">
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                    </select-input>
                    <text-input v-show="form.designado == true"  v-model="form.resolucion" :error="form.errors.resolucion" class="pr-6 pb-8 w-full" label="Numero Resolución" />
                    <text-input required v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full" label="Observaciones" />
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center mt-1">
                    <button v-if="edit" class="btn-login " tabindex="-1" type="button" @click="editar">Guardar Designacion</button>
                    <button v-else class="btn-login" tabindex="-1" type="button" @click="create">Crear</button>
                    <button class="btn-register ml-auto" tabindex="-1" type="button" @click="cancelar">Cancelar</button>
                </div>
        </form>
    </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import Icon from '@/Shared/Icon'
//import Date from '@/Shared/Date'



export default {
    metaInfo() {
        return {
            // title: `${this.nombre} ${this.apellido}`,
        }
    },
    computed:{
        nombre:function () {
            // `this` apunta a la instancia vm
            if(this.form.nombre){
                return this.form.nombre
            }else{
                this.form.nombre = this.$page.props.auth.user.first_name
                return this.$page.props.auth.user.first_name
            }
        },
        apellido:function () {
            // `this` apunta a la instancia vm
            if(this.form.apellido){
                return this.form.apellido
            }else{
                this.form.apellido = this.$page.props.auth.user.last_name
                return this.$page.props.auth.user.last_name
            }
        },
        numero_inscripcion:function(){
            if(this.aspirante.numero_inscripcion != null){
                return this.aspirante.numero_inscripcion
            }else if(this.$page.props.aspirante != null){
                return this.$page.props.aspirante.numero_inscripcion
            }
        },
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        FileInput,
        Icon,
    },
    props: {
        aspirante: Number,
        designacion:Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                aspirante_id: this.aspirante,
                resolucion: '',
                observacion: '',
                designado: 0,
            }),
            edit:false,
        }
    },
    mounted(){
        if(Object.keys(this.designacion).length > 0){
            this.edit = true;
            this.form.resolucion = this.designacion.resolucion
            this.form.observacion = this.designacion.observacion
            this.form.designado = this.designacion.designado
        }else{
            this.form.reset();
        }
        
    },
    methods: {
        create() {
            this.form.post('/asignacion-aspirante',{
                preserveScroll: true,
                onSuccess: () => this.$emit('guardada')
            })
        },
        cancelar(){
            this.$emit('cancelada')
        },
        editar(){
            this.form.put(`/asignacion-aspirante/${this.designacion.id}`,{
                preserveScroll: true,
                onSuccess: () => this.$emit('guardada')
            })
        },
    },
}
</script>
